import { createActionGroup, props } from '@ngrx/store';
import {
	BaseOrderResponse,
	IBaseOMSOrder,
	IBaseOrderEntity,
	IBatchCreateRequestModel,
	IBatchDeleteRequestModel
} from '../../../modules/order';
import { Update } from '@ngrx/entity';
import { BaseOrderAction } from './order.action';

export const DraftAction = createActionGroup({
	source: 'draft',
	events: {
		...BaseOrderAction,
		batchCreate: props<{ requestBody: IBatchCreateRequestModel }>(),
		batchCreated: props<{ sentDraftIds: string[]; draftIds: string[]; removeDraftAfterCreate: boolean }>(),
		batchDelete: props<{ requestBody: IBatchDeleteRequestModel }>(),
		batchDeleted: props<{ draftIds: string[] }>(),
		createDraft: props<{ newDraft: IBaseOrderEntity; sendingDraft: IBaseOMSOrder }>(),
		requestDone: props<{ value?: BaseOrderResponse }>(),
		updateDraft: props<{ draft: Update<IBaseOrderEntity>; sendingDraft: IBaseOMSOrder }>(),
		updateDraftByOmsResponse: props<{ value: BaseOrderResponse }>(),
		deleteDraft: props<{ id: string }>(),
		deletedDraft: props<{ id: string }>()
	}
});
